module.exports = __webpack_public_path__ + "static/images/txcz.c249d28.png";